import { PrescripteurApi } from '@europrocurement/l2d-domain';
import { Box, lighten, useTheme } from '@mui/system';
import React from 'react';
import { Grid, Typography } from '@mui/material';
import { ContactWidget } from '@europrocurement/flexy-components';
import { ContactJsonldTiersReadTiersReadExpanded } from '@europrocurement/l2d-domain/openApi/ApiTiers';

type SelectionContactProps = {
    contact: ContactJsonldTiersReadTiersReadExpanded | undefined;
    setContact: (contact: ContactJsonldTiersReadTiersReadExpanded) => void;
    prescripteur: PrescripteurApi;
};

const SelectionContact: React.FunctionComponent<SelectionContactProps> = function ({
    contact,
    setContact,
    prescripteur,
}) {
    const theme = useTheme();

    return (
        <Box>
            <Typography
                className="title"
                variant="l2dh5"
                sx={{ marginTop: '20px' }}
            >
                Selection du contact
            </Typography>
            <Grid
                container
                spacing={2}
                sx={{ marginTop: '10px' }}
            >
                {prescripteur.contacts.map((cont) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        key={cont['@id']}
                    >
                        <ContactWidget
                            onClick={() => {
                                setContact(cont);
                            }}
                            sx={
                                contact?.id === cont.id
                                    ? {
                                          borderColor: theme.palette.primary.main,
                                          background: lighten(theme.palette.primary.main, 0.95),
                                      }
                                    : {}
                            }
                            prenomContact={cont.prenomContact}
                            nomContact={cont.nomContact}
                            userIdentifier={cont.userIdentifier}
                            telephonesContact={cont.telephonesContact}
                            emailsContact={cont.emailsContact}
                        />
                    </Grid>
                ))}
                {/* <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                >
                    <Box
                        sx={{
                            borderRadius: '15px',
                            minHeight: '75px',
                            backgroundColor: 'background.paper',
                            display: 'flex',
                            flexDirection: 'row',
                            padding: '10px',
                            alignItems: 'center',
                            transition: 'background-color ease-in-out 300ms',
                            ':hover': {
                                backgroundColor: 'text.gris005',
                                cursor: 'pointer',
                                '& > div:last-child': {
                                    opacity: 1,
                                },
                            },
                        }}
                        onClick={() => {
                            modalActions.call(
                                <h1>Contact form placeholder</h1>,
                                // <ContactForm
                                //     prescriber={datasource.selected}
                                //     afterSubmit={() => {
                                //         modalActions.close();
                                //         dispatch(
                                //             selectPrescripteur({
                                //                 id: Number(datasource.selected?.id),
                                //             }),
                                //         );
                                //     }}
                                // />,
                            );
                        }}
                    >
                        <FaOptionIcon
                            {...createIcon.props}
                            size="xl"
                            iconProps={{
                                radius: 100,
                                ...createIcon.props.iconProps,
                            }}
                        />
                        <Typography sx={{ marginLeft: 2 }}>Ajouter un contact</Typography>
                    </Box>
                </Grid> */}
            </Grid>
        </Box>
    );
};
export default SelectionContact;
